import type { CompanyBankDetailsApi } from '@/types/api/companies';

export const FALLBACK_BANK_DETAILS_CURRENCY = 'GBP';

const normaliseCurrency = (value: string | null | undefined) => value?.trim().toUpperCase() ?? '';

const hasBankAccountValues = (detail: CompanyBankDetailsApi) =>
  Boolean(
    detail.accountName?.trim() ||
      detail.sortCode?.trim() ||
      detail.accountNumber?.trim() ||
      detail.ibanNumber?.trim() ||
      detail.swiftBicCode?.trim(),
  );

/**
 * Picks the company bank account matching the given currency, falling back to the GBP account
 * and then to an account with no currency assigned, and finally to the first account so payment
 * instructions are never blank. Rows with no account values at all are skipped.
 */
export function resolveCompanyBankDetails(
  bankDetails: CompanyBankDetailsApi[] | undefined,
  currency: string | undefined,
): CompanyBankDetailsApi | undefined {
  const populated = bankDetails?.filter(hasBankAccountValues);
  if (!populated?.length) return undefined;

  const matching = (target: string | undefined) =>
    target ? populated.find((detail) => normaliseCurrency(detail.currency) === normaliseCurrency(target)) : undefined;

  return (
    matching(currency) ??
    matching(FALLBACK_BANK_DETAILS_CURRENCY) ??
    populated.find((detail) => normaliseCurrency(detail.currency) === '') ??
    populated[0]
  );
}
